export const APP_MOUNTED_EVENT = 'lc-app-mounted'
